const getters = {
  getInformationData: (state) => state.informationData,
  getInformationDataRuleForm: (state) => state.informationData.ruleForm
}

export default getters
